import { isNotNull, isNil } from "@grandvisionhq/utils";
import { NONRECOVERABLE_ERROR, RECOVERABLE_ERROR } from "../../../../../../../../../../../../../../types/types/generic-query-errors.js";
const failedNonRecoverable = {
  type: "FAILED",
  error: NONRECOVERABLE_ERROR
};
const failedRecoverable = {
  type: "FAILED",
  error: RECOVERABLE_ERROR
};
const mapServerToClientPrescriptionCLProduct = (result) => {
  const data = result.getContactLensByPrescription;
  if (data.__typename === "GetContactLensByPrescriptionFailureResponse") {
    data.failures.forEach((failure) => console.error(failure.message));
    if (data.failures.some((failure) => failure.__typename === "ProductNotFoundFailure")) {
      return failedNonRecoverable;
    }
    return failedRecoverable;
  }
  const rawFoundProduct = data.result.variants[0];
  if (!rawFoundProduct) {
    console.error("getContactLensByPrescription query unexpectedly returned an empty array");
    return failedNonRecoverable;
  }
  const { isAllowBackOrder, inventory } = rawFoundProduct;
  const allowBackOrder = isNotNull(isAllowBackOrder) ? isAllowBackOrder : void 0;
  const stockIndicatorStatus = rawFoundProduct.inventory?.stockIndicator === "UNKNOWN" ? "OUT_OF_STOCK" : rawFoundProduct.inventory?.stockIndicator;
  return {
    type: "SUCCESS",
    prescriptionCLProduct: {
      sku: rawFoundProduct.sku,
      allowBackOrder,
      availableQuantity: isNil(inventory?.totalQuantity) ? 0 : inventory?.totalQuantity,
      stockIndicatorStatus
    }
  };
};
export {
  mapServerToClientPrescriptionCLProduct
};
//# sourceMappingURL=map-to-client-prescription-contact-lens-product.js.map
